import { Link } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";
import { Seo } from "../lib/seo";

export default function PaymentFailed() {
  return (
    <div className="mx-auto max-w-md px-6 py-24">
      <Seo title="Pagamento non completato | Herbalife Rossano" description="Il pagamento non è stato completato." noindex />
      <Card className="p-8 rounded-3xl border-slate-200 text-center">
        <XCircle className="w-14 h-14 text-rose-400 mx-auto" />
        <h1 className="mt-4 text-2xl font-bold font-display">Pagamento non completato</h1>
        <p className="mt-2 text-slate-500">Nessun addebito è stato effettuato. I tuoi prodotti sono ancora nel carrello.</p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/carrello"><Button className="rounded-full">Riprova il pagamento</Button></Link>
          <Link to="/catalogo"><Button variant="outline" className="rounded-full">Torna al catalogo</Button></Link>
        </div>
      </Card>
    </div>
  );
}
